// https://success.myshn.net/Data_Protection/Data_Identifiers/U.S._Driver%27s_License_Numbers#:~:text=New%20York%20driver%27s%20license%20numbers,For%20example%2C%20123%20456%20789.&text=North%20Carolina%20driver%27s%20license%20numbers,For%20example%2C%208013303159
const states = [
    {
        // WY
        Id: 1051,
        Regex: '\\d{6}-\\d{3}',
        Mask: '######-###'
    },
    {
        // CO
        Id: 1006,
        Regex: '\\d{2}-\\d{3}-\\d{4}',
        Mask: '##-###-####'
    }
    // Can add more states here
]

function validateLicense (stateId, license) {
    var state = states.find(x => x.Id === stateId)
    if (!state) {
        return true
    }
    if (!license) {
        return false
    }
    return RegExp(state.Regex).test(license)
}

export default {
    validateLicense: validateLicense,
    states: states
}
